"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPersonByIdWrapper$ = exports.GetPersonByIdWrapper$outboundSchema = exports.GetPersonByIdWrapper$inboundSchema = void 0;
exports.getPersonByIdWrapperToJSON = getPersonByIdWrapperToJSON;
exports.getPersonByIdWrapperFromJSON = getPersonByIdWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const getpersonbyidattributes_js_1 = require("./getpersonbyidattributes.js");
/** @internal */
exports.GetPersonByIdWrapper$inboundSchema = z.object({
    attributes: getpersonbyidattributes_js_1.GetPersonByIdAttributes$inboundSchema,
    id: z.string(),
    type: z.literal("person").default("person").optional(),
});
/** @internal */
exports.GetPersonByIdWrapper$outboundSchema = z.object({
    attributes: getpersonbyidattributes_js_1.GetPersonByIdAttributes$outboundSchema,
    id: z.string(),
    type: z.literal("person").default("person"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPersonByIdWrapper$;
(function (GetPersonByIdWrapper$) {
    /** @deprecated use `GetPersonByIdWrapper$inboundSchema` instead. */
    GetPersonByIdWrapper$.inboundSchema = exports.GetPersonByIdWrapper$inboundSchema;
    /** @deprecated use `GetPersonByIdWrapper$outboundSchema` instead. */
    GetPersonByIdWrapper$.outboundSchema = exports.GetPersonByIdWrapper$outboundSchema;
})(GetPersonByIdWrapper$ || (exports.GetPersonByIdWrapper$ = GetPersonByIdWrapper$ = {}));
function getPersonByIdWrapperToJSON(getPersonByIdWrapper) {
    return JSON.stringify(exports.GetPersonByIdWrapper$outboundSchema.parse(getPersonByIdWrapper));
}
function getPersonByIdWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPersonByIdWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetPersonByIdWrapper' from JSON`);
}
//# sourceMappingURL=getpersonbyidwrapper.js.map